module.exports = require("./fr-BE.js");